// Add your custom JS here.

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

(function () {
	'use strict';

	/**
	 * Mega menu (Shop) — markup from inc/class-tdc-mega-menu-walker.php.
	 * Desktop opens on hover / focus via CSS; this wires the chevron button
	 * (the only way to open it on touch / inside the hamburger), plus Esc and
	 * click-outside to close. `is-dismissed` lets Esc override hover/focus
	 * until the pointer or focus leaves the item.
	 */
	function initMegaMenu() {
		var items = document.querySelectorAll( '.site-nav__mega-item' );
		if ( ! items.length ) return;

		function setOpen( item, open ) {
			var toggle = item.querySelector( '.site-nav__mega-toggle' );
			item.classList.toggle( 'is-open', open );
			if ( toggle ) toggle.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
		}

		items.forEach( function ( item ) {
			var toggle = item.querySelector( '.site-nav__mega-toggle' );
			if ( ! toggle ) return;

			toggle.addEventListener( 'click', function () {
				var open = ! item.classList.contains( 'is-open' );
				items.forEach( function ( other ) { if ( other !== item ) setOpen( other, false ); } );
				item.classList.remove( 'is-dismissed' );
				setOpen( item, open );
			} );

			item.addEventListener( 'mouseleave', function () {
				item.classList.remove( 'is-dismissed' );
			} );

			item.addEventListener( 'focusout', function ( e ) {
				if ( ! item.contains( e.relatedTarget ) ) item.classList.remove( 'is-dismissed' );
			} );
		} );

		document.addEventListener( 'click', function ( e ) {
			items.forEach( function ( item ) {
				if ( ! item.contains( e.target ) ) setOpen( item, false );
			} );
		} );

		// Listen on the document: when the panel is open by hover alone,
		// focus (and so the keydown) isn't inside the item.
		document.addEventListener( 'keydown', function ( e ) {
			if ( 'Escape' !== e.key ) return;
			items.forEach( function ( item ) {
				var hasFocus = item.contains( document.activeElement );
				if ( ! hasFocus && ! item.matches( ':hover' ) && ! item.classList.contains( 'is-open' ) ) return;
				setOpen( item, false );
				item.classList.add( 'is-dismissed' );
				var label = item.querySelector( '.site-nav__mega-label' );
				if ( label && hasFocus ) label.focus();
			} );
		} );
	}

	function initFaqAccordions() {
		document.querySelectorAll( '.faq-item' ).forEach( function ( item ) {
			var summary = item.querySelector( 'summary' );
			var answer  = item.querySelector( '.faq-item__answer' );
			if ( ! summary || ! answer ) return;

			summary.addEventListener( 'click', function ( e ) {
				e.preventDefault();

				if ( item.open ) {
					// Closing: rotate icon immediately, collapse height, then remove [open]
					item.classList.add( 'is-closing' );
					answer.style.height = answer.scrollHeight + 'px';
					answer.getBoundingClientRect(); // force reflow
					answer.style.height = '0';
					answer.addEventListener( 'transitionend', function () {
						item.removeAttribute( 'open' );
						item.classList.remove( 'is-closing' );
						answer.style.height = '';
					}, { once: true } );
				} else {
					// Opening: set [open], then animate from 0 to full height
					item.setAttribute( 'open', '' );
					var targetHeight = answer.scrollHeight;
					answer.style.height = '0';
					answer.getBoundingClientRect(); // force reflow
					answer.style.height = targetHeight + 'px';
					answer.addEventListener( 'transitionend', function () {
						answer.style.height = 'auto';
					}, { once: true } );
				}
			} );
		} );
	}

	function initUmHelpText() {
		document.querySelectorAll( '.um-register .um-field-label .um-tip-text' ).forEach( function ( tipText ) {
			var field = tipText.closest( '.um-field' );
			if ( field ) {
				field.appendChild( tipText );
			}
		} );
	}

	function initSignupTypeField() {
		var descriptions = {
			individual: 'Personal / preloved seller',
			business:   'Boutique or small brand',
		};

		document.querySelectorAll( '.um-register .um-field-signup_type .um-field-radio' ).forEach( function ( label ) {
			var input      = label.querySelector( 'input[type="radio"]' );
			var optionSpan = label.querySelector( '.um-field-radio-option' );
			if ( ! input || ! optionSpan ) return;

			// Wrap option label + description in a text column div
			var value      = input.value.toLowerCase();
			var textWrap   = document.createElement( 'div' );
			textWrap.className = 'um-field-radio-text';
			label.insertBefore( textWrap, optionSpan );
			textWrap.appendChild( optionSpan );

			if ( descriptions[ value ] ) {
				var desc       = document.createElement( 'span' );
				desc.className = 'um-field-radio-desc';
				desc.textContent = descriptions[ value ];
				textWrap.appendChild( desc );
			}

			// Keep active class in sync with radio state on click
			label.addEventListener( 'click', function () {
				document.querySelectorAll( '.um-register .um-field-signup_type .um-field-radio' ).forEach( function ( l ) {
					l.classList.remove( 'active' );
				} );
				label.classList.add( 'active' );
			} );
		} );
	}

	function initBrandNameLabel() {
		// Swap the Username field's label to "Brand Name" whenever the
		// signup_type radio is set to Business. Keeps the ✱ required marker
		// and any surrounding whitespace intact. UM renders the radio's
		// `name` as `signup_type[]` (array-syntax), so we scope via the
		// `.um-field-signup_type` wrapper instead of matching on name.
		var typeWrap = document.querySelector( '.um-register .um-field-signup_type' );
		if ( ! typeWrap ) return;
		var typeRadios = typeWrap.querySelectorAll( 'input[type="radio"]' );
		if ( ! typeRadios.length ) return;

		var input = document.querySelector( '.um-register input[data-key="user_login"]' );
		if ( ! input ) return;

		var field = input.closest( '.um-field' );
		var label = field && field.querySelector( '.um-field-label label' );
		if ( ! label ) return;

		var textNode = null;
		for ( var i = 0; i < label.childNodes.length; i++ ) {
			var n = label.childNodes[ i ];
			if ( n.nodeType === 3 && n.textContent.trim() ) {
				textNode = n;
				break;
			}
		}
		if ( ! textNode ) return;

		var raw      = textNode.nodeValue;
		var leading  = raw.match( /^\s*/ )[ 0 ];
		var trailing = raw.match( /\s*$/ )[ 0 ];

		function update() {
			var checked    = typeWrap.querySelector( 'input[type="radio"]:checked' );
			var isBusiness = !! ( checked && /business/i.test( checked.value ) );
			textNode.nodeValue = leading + ( isBusiness ? 'Brand Name' : 'Username' ) + trailing;
		}

		typeRadios.forEach( function ( r ) {
			r.addEventListener( 'change', update );
		} );

		// UM's initSignupTypeField (above) rewires the <label> click handlers
		// after we bind. Delegate a click listener on the wrapper as well so
		// we still catch state changes even if the native `change` event is
		// swallowed by that setup.
		typeWrap.addEventListener( 'click', function () {
			// Defer to next tick so :checked reflects the click.
			setTimeout( update, 0 );
		} );

		update();
	}

	function initListingFilters() {
		document.querySelectorAll( '.js-la-filter-select' ).forEach( function ( select ) {
			select.addEventListener( 'change', function () {
				var url = this.value;
				if ( url ) {
					window.location.href = url;
				}
			} );
		} );
	}

	function initListingFiltersToggle() {
		document.querySelectorAll( '.js-la-filters-toggle' ).forEach( function ( btn ) {
			btn.addEventListener( 'click', function () {
				var id = btn.getAttribute( 'aria-controls' );
				var panel = id ? document.getElementById( id ) : null;
				if ( ! panel ) {
					return;
				}
				var isOpen = panel.classList.toggle( 'is-open' );
				btn.setAttribute( 'aria-expanded', String( isOpen ) );
			} );
		} );
	}

	function initLatestListingsCarousel() {
		document.querySelectorAll( '.js-latest-listings' ).forEach( function ( root ) {
			var swiperEl = root.querySelector( '.swiper' );
			if ( ! swiperEl ) {
				return;
			}

			new Swiper( swiperEl, {
				modules: [ Navigation, Pagination, Autoplay, A11y ],
				slidesPerView: 1,
				spaceBetween: 16,
				loop: true,
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				},
				pagination: {
					el: root.querySelector( '.js-latest-listings-pagination' ),
					clickable: true,
				},
				navigation: {
					prevEl: root.querySelector( '.js-latest-listings-prev' ),
					nextEl: root.querySelector( '.js-latest-listings-next' ),
				},
				breakpoints: {
					576: { slidesPerView: 2, spaceBetween: 20 },
					992: { slidesPerView: 3, spaceBetween: 24 },
				},
				a11y: {
					prevSlideMessage: 'Previous listing',
					nextSlideMessage: 'Next listing',
				},
			} );
		} );
	}

	function initListingArchiveSelect2() {
		if ( typeof window.jQuery === 'undefined' ) {
			return;
		}
		var $ = window.jQuery;
		if ( typeof $.fn.select2 !== 'function' ) {
			return;
		}

		var $selects = $( '.la-sidebar .js-la-filter-select' );
		if ( ! $selects.length ) {
			return;
		}

		$selects.each( function () {
			var $el = $( this );
			$el.select2( {
				minimumResultsForSearch: 0, // always show the search box
				width: '100%',
				containerCssClass: 'tdc-select2',
				dropdownCssClass: 'tdc-select2-dropdown',
				// Keep the dropdown inside the filter group so it stays inside
				// the sidebar's scroll/stacking context on mobile.
				dropdownParent: $el.closest( '.la-filter-group' ),
			} );

			// Force class assignment via API — see note in initCreateListingSelect2.
			var s2 = $el.data( 'select2' );
			if ( s2 ) {
				if ( s2.$container ) s2.$container.addClass( 'tdc-select2' );
				if ( s2.$dropdown ) s2.$dropdown.addClass( 'tdc-select2-dropdown' );
			}
		} );

		// Select2 dispatches `change` via jQuery's .trigger(), which is NOT
		// heard by native addEventListener('change') handlers — so our
		// initListingFilters() URL-navigation handler misses the event on
		// Select2-enhanced dropdowns. Bind the same navigation logic to
		// Select2's own `select2:select` event (jQuery-only) so picking an
		// option navigates to that option's URL as before.
		$selects.on( 'select2:select', function ( e ) {
			var url = e.params && e.params.data ? e.params.data.id : this.value;
			if ( url ) {
				window.location.href = url;
			}
		} );
	}

	function initPriceCurrencySymbol() {
		// Symbol map — keep in sync with tdc_format_price() in functions.php.
		// Prefixed symbols (A$, C$, NZ$…) distinguish dollar currencies.
		var symbols = {
			AUD: 'A$', USD: 'US$', CAD: 'C$', NZD: 'NZ$', SGD: 'S$', HKD: 'HK$',
			GBP: '£',  EUR: '€',
			JPY: '¥',  CNY: '¥',
			INR: '₹',  KRW: '₩',  THB: '฿',  TRY: '₺',  MYR: 'RM',
			CHF: 'Fr', PKR: '₨',
			NOK: 'kr', SEK: 'kr', DKK: 'kr',
			AED: 'د.إ', SAR: '﷼', ZAR: 'R',
		};

		var scope = document.querySelector( '.um-account-main[data-current_tab="edit_listing"] .um-account-tab-edit_listing' ) ||
			document.querySelector( '.um-account-tab-create_listing' ) ||
			document;

		var priceWrap      = scope.querySelector( '.wpcf7-form-control-wrap[data-name="price"]' );
		var currencySelect = scope.querySelector( 'select[name="listing-currency"]' );
		if ( ! priceWrap || ! currencySelect ) return;

		// Prevent negative prices at the browser level.
		var priceInput = priceWrap.querySelector( 'input' );
		if ( priceInput ) {
			priceInput.setAttribute( 'min', '0' );
		}

		// Find the <label> in the same CF7 <p> wrapper as the price input.
		var container  = priceWrap.closest( 'p' ) || priceWrap.parentElement;
		var priceLabel = container && container.querySelector( 'label' );
		if ( ! priceLabel ) return;

		// Inject a <span> before the required * marker.
		// CF7 renders it as either <abbr title="required">*</abbr> or a plain
		// text node — handle both so the result is "Price — A$ *".
		var badge = document.createElement( 'span' );
		badge.className = 'js-price-currency';

		var abbr = priceLabel.querySelector( 'abbr[title="required"]' );
		if ( abbr ) {
			priceLabel.insertBefore( badge, abbr );
		} else {
			// Walk child nodes for a text node containing '*' and split there.
			var nodes   = Array.prototype.slice.call( priceLabel.childNodes );
			var placed  = false;
			for ( var i = 0; i < nodes.length; i++ ) {
				var n = nodes[ i ];
				if ( n.nodeType !== 3 ) continue;
				var idx = n.textContent.indexOf( '*' );
				if ( idx === -1 ) continue;
				var afterNode = document.createTextNode( n.textContent.slice( idx ) );
				n.textContent = n.textContent.slice( 0, idx );
				priceLabel.insertBefore( afterNode, n.nextSibling );
				priceLabel.insertBefore( badge, afterNode );
				placed = true;
				break;
			}
			if ( ! placed ) priceLabel.appendChild( badge );
		}

		function update() {
			// Option values are ACF choice labels ("AUD — Australian Dollar (A$)").
			// Extract the ISO code — the first whitespace-delimited token.
			var raw    = currencySelect.value || '';
			var code   = raw.trim().split( /\s+/ )[ 0 ].toUpperCase();
			var symbol = code ? ( symbols[ code ] !== undefined ? symbols[ code ] : code ) : '';
			badge.textContent = symbol ? ' — ' + symbol : '';
		}

		currencySelect.addEventListener( 'change', update );
		if ( window.jQuery ) {
			window.jQuery( currencySelect ).on( 'select2:select', update );
		}

		update();
	}

	function initCurrencyDefault() {
		// When the seller picks a Location on the Create Listing CF7 form,
		// pre-select the matching currency option so they don't have to
		// think about it. Fully overrideable — this only sets a default.
		var config = window.tdcCurrency;
		if ( ! config || ! config.defaults ) return;

		var scope = document.querySelector( '.um-account-main[data-current_tab="edit_listing"] .um-account-tab-edit_listing' ) ||
			document.querySelector( '.um-account-tab-create_listing' ) ||
			document;

		var locationSelect = scope.querySelector( 'select[name="location"]' );
		var currencySelect = scope.querySelector( 'select[name="listing-currency"]' );
		if ( ! locationSelect || ! currencySelect ) return;

		function apply() {
			var loc  = locationSelect.value || '';
			var pick = config.defaults[ loc ];
			if ( ! pick ) return;

			// Only overwrite when the currency is still on its placeholder
			// (empty value) — don't clobber a manual seller override.
			if ( currencySelect.value ) return;

			// Match the option case-insensitively (ACF sometimes returns
			// lowercased values; CF7 renders them verbatim).
			var opt = Array.prototype.find.call( currencySelect.options, function ( o ) {
				return o.value && o.value.toUpperCase() === pick.toUpperCase();
			} );
			if ( ! opt ) return;

			currencySelect.value = opt.value;
			// If Select2 is wrapping the select, sync the visible label via
			// jQuery-trigger — Select2 listens for jQuery's `change`, not
			// the native DOM event.
			if ( window.jQuery && window.jQuery.fn && window.jQuery.fn.select2 ) {
				window.jQuery( currencySelect ).trigger( 'change' );
			}
		}

		locationSelect.addEventListener( 'change', apply );
		// Also listen for Select2's own event, since Select2 dispatches
		// `change` via jQuery.trigger() which native addEventListener
		// doesn't hear on user-driven picks.
		if ( window.jQuery ) {
			window.jQuery( locationSelect ).on( 'select2:select', apply );
		}

		apply();
	}

	function initCf7RestAuth() {
		// CF7 6.x deletes X-WP-Nonce from its feedback request, so the REST
		// call is unauthenticated and server hooks see no current user. Wrap
		// window.fetch to put the nonce back on CF7 feedback POSTs only.
		var cfg = window.tdcRest;
		if ( ! cfg || ! cfg.nonce || typeof window.fetch !== 'function' ) {
			return;
		}

		var originalFetch = window.fetch;
		window.fetch = function ( input, init ) {
			var url = typeof input === 'string' ? input : ( input && input.url ) || '';
			if ( url.indexOf( 'contact-form-7/v1' ) !== -1 && url.indexOf( '/feedback' ) !== -1 && url.indexOf( '/schema' ) === -1 ) {
				init = init || {};
				var headers = new Headers( init.headers || {} );
				headers.set( 'X-WP-Nonce', cfg.nonce );
				init.headers = headers;
			}
			return originalFetch.call( this, input, init );
		};
	}

	function initMobilePlaceholder() {
		// On the register form, watch the Location dropdown and swap the
		// mobile-number placeholder to a country-appropriate example. Uses
		// tdcMobile.placeholders (keyed by ACF location slug) from PHP;
		// falls back to the generic tdcMobile.fallback for unknown slugs.
		var config = window.tdcMobile;
		if ( ! config || ! config.placeholders ) return;

		var scope = document.querySelector( '.um-register' );
		if ( ! scope ) return;

		var locationSelect = scope.querySelector( '.um-field-location select, select[data-key="location"]' );
		var mobileInput    = scope.querySelector( 'input[data-key="mobile_number"]' );
		if ( ! locationSelect || ! mobileInput ) return;

		function apply() {
			var loc = locationSelect.value || '';
			mobileInput.placeholder = config.placeholders[ loc ] || config.fallback || '';
		}

		locationSelect.addEventListener( 'change', apply );
		// Select2 fires `change` via jQuery.trigger() which native
		// addEventListener doesn't hear — also bind on Select2's own event.
		if ( window.jQuery ) {
			window.jQuery( locationSelect ).on( 'select2:select', apply );
		}

		apply();
	}

	function initRegisterNativeSelects() {
		// UM wraps register dropdowns (Location) in Select2, which hides the
		// real <select>. Phone keyboards' next/previous arrows only step
		// through real form controls, so they skipped Location entirely.
		// On touch devices, drop Select2 and use the native picker instead.
		if ( ! window.jQuery || ! window.matchMedia( '(hover: none) and (pointer: coarse)' ).matches ) {
			return;
		}

		// UM initialises Select2 on jQuery ready, which can run after us —
		// wait for `load` so there's something to destroy.
		window.addEventListener( 'load', function () {
			window.jQuery( '.um-register select.select2-hidden-accessible' ).each( function () {
				window.jQuery( this ).select2( 'destroy' );
				this.classList.add( 'tdc-native-select' );
			} );
		} );
	}

	function initKidsSizing() {
		// Create / Edit Listing: when the listing category is Kids, the Size
		// dropdown offers only kids sizes; otherwise only adult sizes. Kids
		// sizes come from tdcSizes.kidsValues (ACF `listing_size` choices
		// whose key starts with "kids-"). The server re-checks on save.
		var config = window.tdcSizes;
		if ( ! config || ! config.kidsValues ) return;
		var kids = {};
		config.kidsValues.forEach( function ( v ) { kids[ v ] = true; } );

		document.querySelectorAll( 'form' ).forEach( function ( form ) {
			var size = form.querySelector( 'select[name="size"]' );
			if ( ! size ) return;
			var categorySelect = form.querySelector( 'select[name="listing-category"]' );
			// Edit Listing has no category field; it uses the saved one.
			if ( ! categorySelect && ! form.hasAttribute( 'data-listing-category' ) ) return;

			// Keep every option once; rebuild the list from this on change.
			var placeholder = size.querySelector( 'option[value=""]' );
			var all = Array.prototype.filter.call( size.options, function ( o ) { return o.value !== ''; } )
				.map( function ( o ) { return o.cloneNode( true ); } );

			function category() {
				return categorySelect ? categorySelect.value : form.getAttribute( 'data-listing-category' );
			}

			function apply() {
				var isKids  = /^kids?$/i.test( ( category() || '' ).trim() );
				var current = size.value;
				var keep    = all.filter( function ( o ) { return !! kids[ o.value ] === isKids; } );

				size.innerHTML = '';
				if ( placeholder ) size.appendChild( placeholder );
				keep.forEach( function ( o ) { size.appendChild( o.cloneNode( true ) ); } );

				var stillValid = keep.some( function ( o ) { return o.value === current; } );
				size.value = stillValid ? current : '';

				// Refresh Select2's display (used on these forms).
				if ( window.jQuery ) window.jQuery( size ).trigger( 'change' );
			}

			if ( categorySelect ) {
				categorySelect.addEventListener( 'change', apply );
				if ( window.jQuery ) window.jQuery( categorySelect ).on( 'select2:select', apply );
			}
			apply();
		} );
	}

	function initShareCopyLink() {
		// "Copy link" button in template-parts/section-share-listing.php.
		document.querySelectorAll( '.js-share-copy' ).forEach( function ( btn ) {
			var row    = btn.closest( '.share-listing' );
			var status = row && row.querySelector( '.js-share-status' );
			var timer;

			function copied() {
				btn.classList.add( 'is-copied' );
				if ( status ) status.textContent = 'Link copied';
				clearTimeout( timer );
				timer = setTimeout( function () {
					btn.classList.remove( 'is-copied' );
					if ( status ) status.textContent = '';
				}, 2000 );
			}

			// Fallback for browsers/contexts without the async Clipboard API
			// (e.g. non-HTTPS Local URLs).
			function legacyCopy( text ) {
				var ta = document.createElement( 'textarea' );
				ta.value = text;
				ta.setAttribute( 'readonly', '' );
				ta.style.position = 'fixed';
				ta.style.opacity  = '0';
				document.body.appendChild( ta );
				ta.select();
				try {
					document.execCommand( 'copy' );
					copied();
				} catch ( e ) { /* nothing more we can do */ }
				ta.remove();
			}

			btn.addEventListener( 'click', function () {
				var url = btn.getAttribute( 'data-share-url' ) || window.location.href;
				if ( navigator.clipboard && window.isSecureContext ) {
					navigator.clipboard.writeText( url ).then( copied, function () { legacyCopy( url ); } );
				} else {
					legacyCopy( url );
				}
			} );
		} );
	}

	function initListingSubmitRedirect() {
		// After a successful Create Listing submission (CF7 form 174), show
		// the confirmation briefly, then go to My Listings. The account tabs
		// are all rendered on page load, so the My Listings tab on this page
		// is stale — a fresh load is what shows the new listing.
		document.addEventListener( 'wpcf7mailsent', function ( e ) {
			if ( 174 !== Number( e.detail && e.detail.contactFormId ) ) return;

			var link = document.querySelector( '.um-account-side a[href*="my_listings"]' );
			if ( ! link ) return;

			var url = new URL( link.href );
			var id  = e.detail.apiResponse && e.detail.apiResponse.tdc_listing_id;
			if ( id ) url.searchParams.set( 'listing_submitted', id );

			setTimeout( function () {
				window.location.assign( url.toString() );
			}, 2000 );
		} );
	}

	function initPhotoUploadGuard() {
		// Fixes two behaviours of the Drag & Drop CF7 upload plugin on the
		// Create Listing form (we don't edit the plugin's own files):
		//
		// 1. Order. It inserts each new progress row directly under the upload
		//    box, above earlier rows, so the list shows newest-first. Each row
		//    holds its photo's hidden input, so the form also posted the photos
		//    reversed and the seller's LAST photo became the listing cover.
		//    Moving each new row to the end keeps the order they were picked in,
		//    on screen and in the submission.
		//
		// 2. Early submit. It re-enables Submit as soon as ANY photo finishes,
		//    even while others are still uploading — a photo that hasn't
		//    finished isn't sent. Keep Submit disabled (and say why: uploading,
		//    then processing) until every photo has finished or failed.
		document.querySelectorAll( '.codedropz-upload-wrapper' ).forEach( function ( wrapper ) {
			var form   = wrapper.closest( 'form' );
			var submit = form && form.querySelector( 'input[type="submit"], button[type="submit"]' );
			if ( ! submit ) return;

			var isInput    = 'INPUT' === submit.tagName;
			var idleLabel  = isInput ? submit.value : submit.textContent;
			var guarding   = false;

			function rows() {
				return wrapper.querySelectorAll( ':scope > .dnd-upload-status' );
			}

			function pendingRows() {
				return Array.prototype.filter.call( rows(), function ( row ) {
					var finished = row.querySelector( 'input[type="hidden"]' );
					var failed   = row.querySelector( '.has-error, .has-error-msg' );
					return ! finished && ! failed;
				} );
			}

			function pendingCount() {
				return pendingRows().length;
			}

			// The plugin shows 99% once a photo's bytes are sent, then waits
			// for the server to save it before showing 100% — a few seconds
			// for a large phone photo, which looks stuck. Say so on the button.
			function busyLabel( pending ) {
				var allSent = pending.every( function ( row ) {
					var bar = row.querySelector( '.dnd-progress-bar span' );
					return bar && parseInt( bar.textContent, 10 ) >= 99;
				} );
				return allSent ? 'Processing photos…' : 'Uploading photos…';
			}

			function setLabel( text ) {
				if ( isInput ) {
					submit.value = text;
				} else {
					submit.textContent = text;
				}
			}

			function sync() {
				var pending = pendingRows();
				if ( pending.length > 0 ) {
					guarding = true;
					if ( ! submit.disabled ) submit.disabled = true;
					setLabel( busyLabel( pending ) );
				} else if ( guarding ) {
					guarding = false;
					submit.disabled = false;
					setLabel( idleLabel );
				}
			}

			var placed = new WeakSet();

			new MutationObserver( function ( mutations ) {
				mutations.forEach( function ( m ) {
					m.addedNodes.forEach( function ( node ) {
						// A new row lands right after the upload box — move it to the
						// end. Rows are the wrapper's last children, and records
						// arrive in insertion order, so appending each new row keeps
						// the picking order. Each row is moved once only: our own
						// move fires another "added" record, which must be ignored or
						// the rows swap back and forth forever. The plugin finds rows
						// by ID, so moving them is safe.
						if ( 1 === node.nodeType && node.classList.contains( 'dnd-upload-status' ) && node.parentNode === wrapper && ! placed.has( node ) ) {
							placed.add( node );
							wrapper.appendChild( node );
						}
					} );
				} );
				sync();
			} ).observe( wrapper, { childList: true, subtree: true } );

			// The plugin re-enables the button on a 1ms timeout after each
			// photo finishes; put it straight back while others are pending.
			new MutationObserver( function () {
				if ( ! submit.disabled && pendingCount() > 0 ) {
					submit.disabled = true;
				}
			} ).observe( submit, { attributes: true, attributeFilter: [ 'disabled' ] } );

			// Belt and braces for anything that bypasses the disabled state.
			form.addEventListener( 'submit', function ( e ) {
				if ( pendingCount() > 0 ) {
					e.preventDefault();
					e.stopImmediatePropagation();
				}
			}, true );
		} );
	}

	function initPasswordToggles() {
		// Show/hide eye on every password field in UM forms (login, register,
		// password reset, account → Change Password). A real <button> so it
		// works with the keyboard and announces its state to screen readers.
		// Skips fields that already have UM's own toggle (its "Toggle
		// Password Visibility" setting) so they never get two icons.
		var EYE     = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M1.5 12S5.5 4.5 12 4.5 22.5 12 22.5 12 18.5 19.5 12 19.5 1.5 12 1.5 12Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="12" cy="12" r="3.25" stroke="currentColor" stroke-width="1.5"/></svg>';
		var EYE_OFF = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M10.6 5.1A9.7 9.7 0 0 1 12 4.5c6.5 0 10.5 7.5 10.5 7.5a17.6 17.6 0 0 1-3.2 4.1M6.6 6.6C3.3 8.6 1.5 12 1.5 12s4 7.5 10.5 7.5c1.9 0 3.6-.6 5-1.5M9.9 9.9a3.25 3.25 0 0 0 4.2 4.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 3l18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

		document.querySelectorAll( '.um input[type="password"]' ).forEach( function ( input ) {
			if ( input.closest( '.um-field-area-password, .tdc-password-wrap' ) ) return;

			var wrap = document.createElement( 'span' );
			wrap.className = 'tdc-password-wrap';
			input.parentNode.insertBefore( wrap, input );
			wrap.appendChild( input );

			var btn = document.createElement( 'button' );
			btn.type      = 'button';
			btn.className = 'tdc-password-toggle';
			btn.setAttribute( 'aria-label', 'Show password' );
			btn.setAttribute( 'aria-pressed', 'false' );
			if ( input.id ) btn.setAttribute( 'aria-controls', input.id );
			btn.innerHTML = EYE;
			wrap.appendChild( btn );

			btn.addEventListener( 'click', function () {
				var show = 'password' === input.type;
				input.type = show ? 'text' : 'password';
				btn.innerHTML = show ? EYE_OFF : EYE;
				btn.setAttribute( 'aria-label', show ? 'Hide password' : 'Show password' );
				btn.setAttribute( 'aria-pressed', show ? 'true' : 'false' );
			} );
		} );

		// Never submit a revealed password as a plain text field — browsers may offer to
		// save it as a normal form value. Flip any revealed field back first.
		document.addEventListener( 'submit', function ( e ) {
			e.target.querySelectorAll( '.tdc-password-wrap input[type="text"]' ).forEach( function ( input ) {
				input.type = 'password';
			} );
		}, true );
	}

	function initUmScrollToFirstError() {
		// UM validates on the server and reloads the page with errors, which
		// leaves the visitor at the top. Bring the first error into view
		// (centred, so the sticky header doesn't cover it) and focus its
		// field so they can fix it straight away.
		var error = document.querySelector( '.um form .um-field-error, .um form p.um-notice.err' );
		if ( ! error ) return;

		var field = error.closest( '.um-field' ) || error;

		// Wait for `load` so fonts and Select2 have settled and the
		// position doesn't shift after we scroll.
		window.addEventListener( 'load', function () {
			var control = field.querySelector( 'input:not([type="hidden"]), select, textarea' );

			// Select2 hides the real <select>; focus its visible control
			// instead. Focusing the hidden one makes Select2 re-focus its own
			// element without preventScroll, which jumps the page and cancels
			// our smooth scroll.
			if ( control && control.classList.contains( 'select2-hidden-accessible' ) ) {
				control = field.querySelector( '.select2-selection' );
			}

			// Focus first, then scroll on the next frame, so nothing that
			// focus triggers can interrupt the scroll.
			if ( control ) {
				control.focus( { preventScroll: true } );
			}

			window.requestAnimationFrame( function () {
				field.scrollIntoView( { behavior: 'smooth', block: 'center' } );
			} );
		} );
	}

	function initRegisterUsernameCheck() {
		var config = window.tdcRegister;
		if ( ! config || ! config.ajaxUrl ) {
			return;
		}

		// UM suffixes the field name with `-<form_id>` (e.g. user_login-2), so
		// match on data-key which is always the raw metakey.
		var input = document.querySelector( '.um-register input[data-key="user_login"]' );
		if ( ! input ) {
			return;
		}

		var ERROR_FLAG = 'tdcAjaxUsername';

		function removeAjaxError() {
			var field = input.closest( '.um-field' );
			if ( ! field ) return;
			var existing = field.querySelector( '[data-' + ERROR_FLAG.replace( /([A-Z])/g, '-$1' ).toLowerCase() + ']' );
			if ( existing ) existing.remove();
			input.removeAttribute( 'aria-invalid' );
			input.removeAttribute( 'aria-errormessage' );
		}

		function showAjaxError( message ) {
			var field = input.closest( '.um-field' );
			if ( ! field ) return;

			removeAjaxError();

			var errorId = 'um-error-for-' + ( input.getAttribute( 'id' ) || 'user_login' );
			var div     = document.createElement( 'div' );
			div.className        = 'um-field-error';
			div.id               = errorId;
			div.dataset[ ERROR_FLAG ] = '1';
			div.innerHTML        = '<span class="um-field-arrow"><i class="um-faicon-caret-up"></i></span>';
			div.appendChild( document.createTextNode( message ) );

			var area = field.querySelector( '.um-field-area' );
			if ( area && area.parentNode === field ) {
				area.insertAdjacentElement( 'afterend', div );
			} else {
				field.appendChild( div );
			}

			input.setAttribute( 'aria-invalid', 'true' );
			input.setAttribute( 'aria-errormessage', errorId );
		}

		// The previous result no longer applies once the visitor edits the
		// field — clear it straight away; blur re-checks the new value.
		input.addEventListener( 'input', removeAjaxError );

		input.addEventListener( 'blur', function () {
			var value = input.value.trim();
			if ( ! value ) {
				removeAjaxError();
				return;
			}

			var body = new URLSearchParams();
			body.append( 'action', 'tdc_check_username' );
			body.append( 'nonce', config.nonce );
			body.append( 'username', value );

			fetch( config.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
				body: body.toString(),
			} )
				.then( function ( res ) { return res.ok ? res.json() : null; } )
				.then( function ( json ) {
					if ( ! json || ! json.success ) return;
					// Ignore a late reply for a value that's since been edited.
					if ( input.value.trim() !== value ) return;
					if ( json.data && json.data.blocked ) {
						showAjaxError( config.blockedMsg || config.takenMsg );
					} else if ( json.data && json.data.exists ) {
						showAjaxError( config.takenMsg );
					} else {
						removeAjaxError();
					}
				} )
				.catch( function () { /* network error — leave field alone */ } );
		} );
	}

	function initCreateListingSelect2() {
		// jQuery + Select2 are provided by UM on account pages. Bail out
		// silently on pages where they aren't loaded (i.e. everywhere else).
		if ( typeof window.jQuery === 'undefined' ) {
			return;
		}
		var $ = window.jQuery;
		if ( typeof $.fn.select2 !== 'function' ) {
			return;
		}

		var $selects = $( '.um-account-tab-create_listing select.wpcf7-select, .um-account-tab-edit_listing select.form-select' );
		if ( ! $selects.length ) {
			return;
		}

		$selects.each( function () {
			var $el = $( this );
			// Placeholder = the first "empty" option ("Select Brand" etc.)
			// that CF7's `first_as_label` renders.
			var placeholder = $el.find( 'option[value=""]' ).first().text() || '';
			$el.select2( {
				placeholder: placeholder,
				allowClear: false,
				minimumResultsForSearch: 0, // always show the search box
				width: '100%',
				containerCssClass: 'tdc-select2',
				dropdownCssClass: 'tdc-select2-dropdown',
				// CF7 wraps each control; the Edit Listing form uses .form-field.
				dropdownParent: $el.closest( '.wpcf7-form-control-wrap, .form-field' ),
			} );

			// Belt-and-braces: `containerCssClass`/`dropdownCssClass` don't
			// always land on the rendered nodes in Select2 4.0.13 (varies by
			// timing / order of init). Force the class assignment via the
			// Select2 API so our .tdc-select2 CSS rules always match.
			var s2 = $el.data( 'select2' );
			if ( s2 ) {
				if ( s2.$container ) s2.$container.addClass( 'tdc-select2' );
				if ( s2.$dropdown ) s2.$dropdown.addClass( 'tdc-select2-dropdown' );
				// Server-side validation errors on the Edit Listing form.
				if ( s2.$container && $el.attr( 'aria-invalid' ) === 'true' ) {
					s2.$container.addClass( 'select2-container--is-invalid' );
				}
			}
		} );

		// CF7's client-side validation adds `.wpcf7-not-valid` to the native
		// <select>. Mirror that to the Select2 container so the burgundy
		// error border applies visibly.
		$selects.on( 'change select2:select', function () {
			var $el = $( this );
			$el.next( '.select2-container' ).toggleClass(
				'select2-container--is-invalid',
				$el.hasClass( 'wpcf7-not-valid' )
			);
		} );
	}

	function initEditListingPhotos() {
		// Photo manager on the Edit Listing form: existing + newly picked
		// photos share one sortable grid. Each tile carries a hidden
		// photo_order[] token — "e:<attachment id>" or "n:<index>" into the
		// new_images[] file input — so the server can save the seller's order.
		var manager = document.querySelector( '.js-photo-manager' );
		if ( ! manager ) return;

		var form     = manager.closest( 'form' );
		var grid     = manager.querySelector( '.js-photo-grid' );
		var input    = manager.querySelector( '.js-photo-input' );
		var addBtn   = manager.querySelector( '.js-photo-add' );
		var status   = manager.querySelector( '.js-photo-status' );
		var min      = parseInt( manager.getAttribute( 'data-min' ), 10 ) || 0;
		var max      = parseInt( manager.getAttribute( 'data-max' ), 10 ) || Infinity;
		var maxBytes = parseInt( manager.getAttribute( 'data-max-bytes' ), 10 ) || Infinity;
		var allowed  = /\.(jpe?g|png|gif)$/i;
		var canSync  = typeof window.DataTransfer === 'function';

		function items() {
			return grid.querySelectorAll( '.js-photo-item' );
		}

		// Rewrite the file input from the new tiles in DOM order and re-index
		// their n:<index> tokens to match.
		function sync() {
			var dt = canSync ? new window.DataTransfer() : null;
			var n  = 0;
			Array.prototype.forEach.call( items(), function ( item ) {
				if ( ! item._file ) return;
				if ( dt ) dt.items.add( item._file );
				item.querySelector( 'input[name="photo_order[]"]' ).value = 'n:' + n;
				n++;
			} );
			if ( dt ) input.files = dt.files;

			var count = items().length;
			addBtn.hidden = count >= max;
			status.textContent = count + ' / ' + max + ' photos';
			status.classList.toggle( 'is-invalid', count < min );
		}

		function removeButton() {
			var btn = document.createElement( 'button' );
			btn.type = 'button';
			btn.className = 'tdc-photo-manager__remove js-photo-remove';
			btn.setAttribute( 'aria-label', 'Remove photo' );
			btn.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
			return btn;
		}

		function addFile( file ) {
			var item = document.createElement( 'li' );
			item.className = 'tdc-photo-manager__item js-photo-item';
			item._file = file;

			var img = document.createElement( 'img' );
			img.className = 'tdc-photo-manager__img';
			img.alt = '';
			img.src = URL.createObjectURL( file );

			var order = document.createElement( 'input' );
			order.type = 'hidden';
			order.name = 'photo_order[]';

			var cover = document.createElement( 'span' );
			cover.className = 'tdc-photo-manager__cover';
			cover.textContent = 'Cover';

			item.appendChild( img );
			item.appendChild( order );
			item.appendChild( cover );
			item.appendChild( removeButton() );
			grid.appendChild( item );
		}

		input.addEventListener( 'change', function () {
			// Without DataTransfer we can't merge picks, so the input keeps
			// only the latest selection — drop previously picked tiles.
			if ( ! canSync ) {
				Array.prototype.forEach.call( items(), function ( item ) {
					if ( item._file ) item.remove();
				} );
			}

			// input.files is about to be rewritten by sync(); copy first.
			var picked  = Array.prototype.slice.call( input.files );
			var skipped = [];
			picked.forEach( function ( file ) {
				if ( items().length >= max ) {
					skipped.push( file.name + ' (limit reached)' );
				} else if ( ! allowed.test( file.name ) ) {
					skipped.push( file.name + ' (JPG, PNG or GIF only)' );
				} else if ( file.size > maxBytes ) {
					skipped.push( file.name + ' (over 10 MB)' );
				} else {
					addFile( file );
				}
			} );
			sync();
			if ( skipped.length ) {
				status.textContent += ' — skipped: ' + skipped.join( ', ' );
			}
		} );

		grid.addEventListener( 'click', function ( e ) {
			var btn = e.target.closest( '.js-photo-remove' );
			if ( ! btn ) return;
			var item = btn.closest( '.js-photo-item' );
			if ( item._file ) URL.revokeObjectURL( item.querySelector( 'img' ).src );
			item.remove();
			sync();
		} );

		if ( typeof window.Sortable === 'function' ) {
			window.Sortable.create( grid, {
				animation: 150,
				draggable: '.js-photo-item',
				filter: '.js-photo-remove',
				preventOnFilter: false,
				ghostClass: 'is-ghost',
				onEnd: sync,
			} );
		}

		form.addEventListener( 'submit', function ( e ) {
			var count = items().length;
			if ( count < min || count > max ) {
				e.preventDefault();
				status.textContent = 'Please include between ' + min + ' and ' + max + ' photos.';
				status.classList.add( 'is-invalid' );
				manager.scrollIntoView( { behavior: 'smooth', block: 'center' } );
			}
		} );

		sync();
	}

	// Patch fetch immediately — CF7 reads window.fetch at submit time, so this
	// just needs to be installed before the first form submission.
	initCf7RestAuth();

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initMegaMenu );
		document.addEventListener( 'DOMContentLoaded', initFaqAccordions );
		document.addEventListener( 'DOMContentLoaded', initUmHelpText );
		document.addEventListener( 'DOMContentLoaded', initSignupTypeField );
		document.addEventListener( 'DOMContentLoaded', initBrandNameLabel );
		document.addEventListener( 'DOMContentLoaded', initListingFilters );
		document.addEventListener( 'DOMContentLoaded', initListingFiltersToggle );
		document.addEventListener( 'DOMContentLoaded', initLatestListingsCarousel );
		document.addEventListener( 'DOMContentLoaded', initCreateListingSelect2 );
		document.addEventListener( 'DOMContentLoaded', initListingArchiveSelect2 );
		document.addEventListener( 'DOMContentLoaded', initPriceCurrencySymbol );
		document.addEventListener( 'DOMContentLoaded', initCurrencyDefault );
		document.addEventListener( 'DOMContentLoaded', initMobilePlaceholder );
		document.addEventListener( 'DOMContentLoaded', initRegisterNativeSelects );
		document.addEventListener( 'DOMContentLoaded', initKidsSizing );
		document.addEventListener( 'DOMContentLoaded', initShareCopyLink );
		document.addEventListener( 'DOMContentLoaded', initListingSubmitRedirect );
		document.addEventListener( 'DOMContentLoaded', initPhotoUploadGuard );
		document.addEventListener( 'DOMContentLoaded', initPasswordToggles );
		document.addEventListener( 'DOMContentLoaded', initUmScrollToFirstError );
		document.addEventListener( 'DOMContentLoaded', initRegisterUsernameCheck );
		document.addEventListener( 'DOMContentLoaded', initEditListingPhotos );
	} else {
		initMegaMenu();
		initFaqAccordions();
		initUmHelpText();
		initSignupTypeField();
		initBrandNameLabel();
		initListingFilters();
		initListingFiltersToggle();
		initLatestListingsCarousel();
		initCreateListingSelect2();
		initListingArchiveSelect2();
		initPriceCurrencySymbol();
		initCurrencyDefault();
		initMobilePlaceholder();
		initRegisterNativeSelects();
		initKidsSizing();
		initShareCopyLink();
		initListingSubmitRedirect();
		initPhotoUploadGuard();
		initPasswordToggles();
		initUmScrollToFirstError();
		initRegisterUsernameCheck();
		initEditListingPhotos();
	}
} )();
